/* Gallery videos: play with sound when the visitor taps a video thumbnail (a tap allows sound).
   If the browser still refuses, play muted and show a sound button. */
(function () {
  var ICON_OFF = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 9v6h4l5 4V5L8 9z"/><path d="M17 9l4 6M21 9l-4 6"/></svg>';
  var ICON_ON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 9v6h4l5 4V5L8 9z"/><path d="M16 9a4 4 0 0 1 0 6M18.5 6.5a8 8 0 0 1 0 11"/></svg>';
  function soundButton(v, box) {
    var old = box.querySelector('.ew-sound'); if (old) old.remove();
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'ew-sound'; b.setAttribute('aria-label', 'Sound on / off');
    var paint = function () { b.innerHTML = v.muted ? ICON_OFF : ICON_ON; };
    b.addEventListener('click', function (e) { e.stopPropagation(); v.muted = !v.muted; if (!v.muted) v.volume = 1; paint(); });
    paint(); box.appendChild(b);
    return paint;
  }
  function playWithSound(v, box) {
    v.muted = false; v.volume = 1;
    var paint = soundButton(v, box);
    var p = v.play();
    if (p && p.catch) p.catch(function () { v.muted = true; paint(); v.play().catch(function () {}); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.ew-gallery__thumb');
    if (!t) { 
      var box0 = e.target.closest('.ew-gallery__main');
      if (box0 && !e.target.closest('.ew-sound')) { var v0 = box0.querySelector('video'); if (v0 && v0.muted) { v0.muted = false; v0.volume = 1; var b0 = box0.querySelector('.ew-sound'); if (b0) b0.click(), b0.click(); } }
      return;
    }
    var gal = t.closest('[data-ew-gallery]'); if (!gal) return;
    var box = gal.querySelector('.ew-gallery__main');
    setTimeout(function () {
      var v = box.querySelector('video');
      var s = box.querySelector('.ew-sound');
      if (v) playWithSound(v, box); else if (s) s.remove();
    }, 0);
  });
  function initFirst() {
    document.querySelectorAll('.ew-gallery__main video').forEach(function (v) {
      var box = v.closest('.ew-gallery__main');
      if (!box.querySelector('.ew-sound')) soundButton(v, box);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFirst); else initFirst();
})();